<template>
    <v-dialog
        persistent
        v-model="dialog"
        width="500"
        @input="v => v || $_closeDialog()"
        >
      <template v-slot:activator="{ on, attrs }">
        <img :src="src" v-bind="attrs " v-bind:style='imgStyle' alt="Foto salva para possivel envio"
        v-on="on" v-on:click="$_openDialog() "/>
      </template>
      <v-card v-if="card">
        <v-card-title v-bind:class='classe' id='card-superior'>
            <div id='label'>
              {{titulo}}
            </div>
            <v-icon large id='icone'>
              {{icone}}
            </v-icon>
          </v-card-title>
        <v-card-text>
          {{mensagem}}
        </v-card-text>
         <div id='center'>
          <div id='nomearquivo-wrapper'>
              <v-text-field
              v-if="btnSetup"
              :readonly="enviando"
              outlined
              ref='dialogAtual'
              id='nomearquivo-edit'
              type=text
              maxlength="12"
              label="Nome"
              v-on:keydown="stopPipe()"
              v-on:keyup="stopPipe()"
              v-model='edtTxt'
              ></v-text-field>
          </div>
        </div>
        <v-divider>
        </v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if="btnSetup">
          <v-btn v-if="!enviando"  class='black--text'
            text
            @click="btnSetup=true;dialog=false;$_closeDialog();">
            Cancelar
          </v-btn>
          <v-btn v-if="!enviando" class='btn white--text'
            color="blue-grey"
            @click="$_Upload()" >
            Enviar
          </v-btn>
          <div v-else class="flex">
            <p>
              Enviando Arquivo
            </p>
            <v-progress-circular
              indeterminate
              color="green"
              class="circular"
            ></v-progress-circular>
          </div>
          </div>
          <!-- <div v-else > -->
            <!-- <v-btn class='black--text' v-if="exibeBotaoReenviar"
              @click="dialog=false;$_ConfirmDownload()">
              Salvar
            </v-btn> -->
            <v-btn v-else class='white--text'
              color="blue-grey"
              @click="dialog=false;$_ConfirmDelete()">
              Voltar
            </v-btn>
          <!-- </div> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import api from '@/services/api-varejoweb';

import errorHandler from '@/utils/error-handler';

import moment from 'moment-timezone';
import { mapState } from 'vuex';
import db from '@/plugins/dexie';
import { tempMedia } from '@/utils/tempMedia';

export default {
  props: {
    src: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      dialog: false,
      snackbar: false,
      text: null,
      imageURL: null,
      id: this.$route.params.id,
      imgStyle: null,
      card: true,
      edtTxt: this.$route.params.valor,

      // Customização da caixa de texto;
      btnSetup: true,
      classe: null,
      icone: null,
      mensagem: null,
      titulo: null,
      enviando: false,
      exibeBotaoReenviar: false,
      rotaapi: null,
    };
  },

  computed: {
    ...mapState({
      $$_ordem: (state) => state.ordemcarregamento.ordem,
    })
  },
  methods: {

    async ConfirmDownload() {
      errorHandler('Um nome de documento é obrigatório');
    },

    async $_DownloadAll() {
      this.$emit('downloadall');
      this.$_closeDialog();
    },

    async $_ConfirmDelete() {
      if (this.titulo === 'Sucesso' || this.titulo === 'Erro') {
        this.$emit('remove');
      }
      this.$_closeDialog();
    },

    async $_closeDialog() {
      this.imgStyle = null;
    },

    async $_openDialog() {
      this.imgStyle = 'border: 6px solid hsl(210,70%,50%)';
      setTimeout(() => {
        this.$refs.dialogAtual.focus();
      }, 0);
      this.newDialog();
    },

    async $_Upload() {
      if (!this.edtTxt) {
        console.log(this.edtTxt);
        errorHandler('Um nome de documento é obrigatório');
        return;
      }
      const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n) {
          u8arr[n - 1] = bstr.charCodeAt(n - 1);
          n -= 1; // to make eslint happy
        }
        return new File([u8arr], filename, { type: mime });
      };
      const formData = new FormData();
      try {
        const date = await this.preciseDate(new Date());

        this.edtTxt = this.edtTxt.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        const nome = `${this.edtTxt}|${this.id}|_,${date}`;
        this.file = await dataURLtoFile(this.src, nome);
        if (this.file.size > 10 * 1000 * 1000) {
          errorHandler('O arquivo é maior que 10MB e não pode ser enviado.');
          return;
        }
        formData.append('image', this.file, nome);
      } catch (err) {
        this.newDialog('Erro', err);
        return;
      }

      this.rotaapi = null;
      if (this.$route.params.tipo === 'coleta') {
        this.enviando = true;
        try {
          console.log(this.file);
          if (tempMedia[this.$route.params.id]) {
          tempMedia[this.$route.params.id].push({
            dados: URL.createObjectURL(this.file),
            blob: this.file,
            tipo: this.file.type.split('/')[0],
          })
          } else {
            tempMedia[this.$route.params.id] = [{
              dados: URL.createObjectURL(this.file),
              blob: this.file,
              tipo: this.file.type.split('/')[0],
            }]
          }

          this.enviando = false;
          this.newDialog('Sucesso');
        } catch (err) {
          this.enviando = false;
          this.newDialog('Erro', err);
        }
        return;
      }

      this.enviando = true;
      api.post(this.rotaapi, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.enviando = false;
        this.newDialog('Sucesso');
      }).catch(async (err) => {
        let errorMessage = err;
        if (!err.response) {
          // network error
          errorMessage = `Falha de conexão, uma cópia da imagem foi feito para ser reenviado após a conexão
          ser re-estabelecida.`;
          
          const date = await this.preciseDate(new Date());
          
          await db.imagem.add({
            relacao: this.$route.params.tipo,
            idrelacao: this.id,
            base64: this.src,
            rotaapi: this.rotaapi,
            datacriacao: moment().utc().format('DD/MM/YYYY HH:mm'),
            nomearquivo: `${this.edtTxt}|${this.id}|_,${date}`,
            tentativa: 0,
          });
        }
        this.enviando = false;
        this.newDialog('Erro', errorMessage);
      }).finally(() => {
        this.$_salvaArquivoGaleria();
      });
    },

    async $_salvaArquivoGaleria() {
      const el = document.createElement('a');
      el.href = this.$props.src;
      el.download = `${this.edtTxt}_${moment().utc().format('DD_MM_YYYY_HH_mm_SS')}`;
      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },

    // maxContentLength: Infinity,
    // maxBodyLength: Infinity,

    stopPipe() {
      try {
        this.edtTxt = this.edtTxt.split('/').join('');
        this.edtTxt = this.edtTxt.split('|').join('');
        this.edtTxt = this.edtTxt.split(' ').join('');
        this.edtTxt = this.edtTxt.split('\\').join('');
      } catch {
        console.log('Input vazio');
      }
    },

    async preciseDate(date) {
      const dateArray = [
        (`00${date.getDate()}`).slice(-2),
        (`00${date.getMonth() + 1}`).slice(-2),
        date.getFullYear(),
        '_',
        (`00${date.getHours()}`).slice(-2),
        (`00${date.getMinutes()}`).slice(-2),
        (`00${date.getSeconds()}`).slice(-2),
      ];
      return dateArray.join();
    },

    async newDialog(param, err) {
      // this.exibeBotaoReenviar = false;
      switch (param) {
        case 'Erro':
          // this.exibeBotaoReenviar = true;
          this.MontaDialog([
            'Erro',
            'mdi-alert-circle',
            'headline red white--text',
            err,
          ]);
          this.btnSetup = false;
          break;
        case 'Sucesso':
          this.MontaDialog([
            'Sucesso',
            'mdi-checkbox-marked-circle-outline',
            'headline light-blue darken-4 white--text',
            'A imagem foi enviada com sucesso!',
          ]);
          this.btnSetup = false;
          break;
        default:
          this.MontaDialog([
            'Transferência',
            'mdi-content-save',
            'headline light-blue darken-4 white--text',
            'Digite um nome de até 12 digitos e selecione \'Enviar\' para confirmar.',
          ]);
          this.btnSetup = true;
          break;
      }
    },

    async MontaDialog(params) {
      [this.titulo, this.icone, this.classe, this.mensagem, this.btnSetup] = params;
    },
  },
};

</script>

<style scoped>
img {
    height: 100%;
}

#aceitar {
  float: left;
  position: relative;
}

#card-superior {
  display: flex;
  justify-content: space-between;
  margin-top: -5%;
}

#icone {
  color: white;
}

#label {
  margin-top: 5%;
}

#nomearquivo-edit input{
  font-size: 1.9em;
}

#nomearquivo-wrapper {
  width: 42%;
  display: flex;
  height: 20%;
}

#center {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: -10%;
}

.flex {
  display: flex;
  margin: 0;
}

.flex p {
  margin-right: 20px;
}

.flex .circular {
  position: relative;
  top: -4px;
}

</style>
